import React, { lazy } from 'react';
import { ShoppingBag, ArrowRight, Boxes, Home, Factory, Wrench, Store } from 'lucide-react';
// Exact manufacturer/category list from https://www.clrmarine.com/Pumps
// Names, hrefs, image src, and alt values preserved verbatim from the source page.
const manufacturers: {
  name: string;
  href: string;
  src: string;
  alt: string;
}[] = [{
  name: 'Albine Group',
  href: '693m4/manufacturers/a/albin-group.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FC%2Falbin-pump-marine.jpg&opt=w3',
  alt: 'albin-pump-marine'
}, {
  name: 'Ampco Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/a/ampco-marine-industrial-pumps.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FAmpco%2FAmpco-Pumps-Company.jpg&opt=w3',
  alt: 'Ampco-Pumps-Company'
}, {
  name: 'AMT Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/a/amt-pumps-industrial-and-commercial-pumps.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FAMT-Pumps.jpg&opt=w3',
  alt: 'AMT-Pumps'
}, {
  name: 'Berkeley Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/b/berkeley-pumps.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FBerkeley-Pump-Logo.jpg&opt=w3',
  alt: 'Berkeley'
}, {
  name: 'Bosworth Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/b/bosworth-pumps.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FThe-Bosworth-Company.jpg&opt=w3',
  alt: 'The-Bosworth-Company'
}, {
  name: 'Burks Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/b/burks-pumps.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FBurks-Pump-Company.jpg&opt=w3',
  alt: 'Burks-Pump-Company'
}, {
  name: 'Cal Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/c/cal-pump.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FCal-Pump.jpg&opt=w3',
  alt: 'Cal-Pump'
}, {
  name: 'Calpeda Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/c/calpeda-pumps.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FCalpeda_Pumps%2FCalpeda.jpg&opt=w3',
  alt: 'Calpeda_Pumps_&_Parts'
}, {
  name: 'Cat Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/c/cat-pump.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FCat-Pumps.jpg&opt=w3',
  alt: 'Cat-Pumps'
}, {
  name: 'Caterpillar Marine Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/c/caterpillar-marine-pumps.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FCaterpillar-Marine-Pumps.jpg&opt=w3',
  alt: 'Caterpillar-Marine-Pumps'
}, {
  name: 'Cummins Marine Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/c/cummins-marine-engine-pumps.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FC%2FCummins.jpg&opt=w3',
  alt: 'Cummins'
}, {
  name: 'Danfoss Pumps & Parts',
  href: 'https://www.clrmarine.com/462m4/manufacturers/d/danfoss-pumps-for-marine-industry.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FDanfoss%2FDanfoss.jpg&opt=w3',
  alt: 'Danfoss-Company'
}, {
  name: 'Detroit Diesel Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/d/detroit-diesel-pumps.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FDetroit-Diesel-Logo.jpg&opt=w3',
  alt: 'Detroit Diesel'
}, {
  name: 'Fill-Rite Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/f/fill-rite-pumps.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FFill-Rite.jpg&opt=w3',
  alt: 'Fill-Rite'
}, {
  name: 'Finish Thompson Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/f/finish-thompson-pumps.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FFinish-Thompson-Pumps.jpg&opt=w3',
  alt: 'Finish-Thompson-Pumps'
}, {
  name: 'Flojet Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/f/flojet-pumps-for-marine-rv.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FFlojet.jpg&opt=w3',
  alt: 'Flojet'
}, {
  name: 'Flotec Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/f/flotec-water-pumps-transfer-systems.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FFlotec.jpg&opt=w3',
  alt: 'Flotec'
}, {
  name: 'Fluid-o-Tech',
  href: 'https://www.clrmarine.com/462m4/manufacturers/f/fluid-o-tech-pumps.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FFluid-o-Tech%2FFluid-o-Tech_logo.jpg&opt=w3',
  alt: 'Fluid-o-Tech_logo'
}, {
  name: 'Galley Maid',
  href: 'https://www.clrmarine.com/462m4/manufacturers/g/galley-maid-pumps.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FGalley-Maid.jpg&opt=w3',
  alt: 'Galley-Maid'
}, {
  name: 'General Pump',
  href: 'https://www.clrmarine.com/462m4/manufacturers/g/general-pump.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FGeneral-Pump.jpg&opt=w3',
  alt: 'General-Pump'
}, {
  name: 'Gianneschi Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/g/gianneschi-pumps.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FGianneschi%2FGianneschi-large.jpg&opt=w3',
  alt: 'Gianneschi-Pumps'
}, {
  name: 'Globe Marine Impellers',
  href: 'https://www.clrmarine.com/462m4/manufacturers/g/globe-marine-impellers.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FGlobe-Rubber-Logo.jpg&opt=w3',
  alt: 'Globe-Rubber'
}, {
  name: 'GOODYEAR',
  href: 'https://www.clrmarine.com/462m4/manufacturers/g/goodyear-marine-hoses.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FGoodyear%2FGoodyear%20Rubber%20Products.jpg&opt=w3',
  alt: 'GOODYEAR'
}, {
  name: 'Gorman-Rupp-Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/g/gorman-rupp-pumps.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FGorman-Rupp%2FGorman-Rupp_logo.jpg&opt=w3',
  alt: 'Gorman-Rupp_logo'
}, {
  name: 'Goulds Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/g/goulds-pumps.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FGoulds.jpg&opt=w3',
  alt: 'Goulds'
}, {
  name: 'Groco Strainers and Fittings',
  href: 'https://www.clrmarine.com/462m4/manufacturers/g/groco-valves-strainers.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FGroco-Logo.jpg&opt=w3',
  alt: 'Groco'
}, {
  name: 'Haight Pump',
  href: 'https://www.clrmarine.com/462m4/manufacturers/h/haight-pump.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FHaight%20Pump%2FHaight_Pump.jpg&opt=w3',
  alt: 'Haight_Pump'
}, {
  name: 'Headhunter Pumps',
  href: 'https://www.clrmarine.com/693m4/manufacturers/h/headhunter-pumps.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FHeadHunter-Pumps%2FHeadhunter-logo.jpg&opt=w3',
  alt: 'Headhunter-logo'
}, {
  name: 'Hydra-Cell Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/h/hydra-cell-pumps.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FHydra-Cell%2FHydra-Cell.jpg&opt=w3',
  alt: 'Hydra-Cell-logo'
}, {
  name: 'Hypro Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/h/hypro-pumps.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FHypro.jpg&opt=w3',
  alt: 'Hypro'
}, {
  name: 'Iwaki Pumps',
  href: 'https://www.clrmarine.com/693m4/manufacturers/i/iwaki-pumps.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FIwaki-America.jpg&opt=w3',
  alt: 'Iwaki-America'
}, {
  name: 'Jabsco Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/j/jabsco-pumps.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FJabsco.jpg&opt=w3',
  alt: 'Jabsco'
}, {
  name: 'Jacuzzi Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/j/jacuzzi-pumps.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FJacuzzi-Pump-Parts-Logo.jpg&opt=w3',
  alt: 'Jacuzzi-Pump-Parts'
}, {
  name: 'JMP Marine Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/j/jmp-marine-pumps.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FJMP%2FJMP-Marine-logo.jpg&opt=w3',
  alt: 'JMP-Marine'
}, {
  name: 'John Deere Marine Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/j/john-deere-pumps.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FJohn-Deere-Marine.jpg&opt=w3',
  alt: 'John-Deere-Marine'
}, {
  name: 'Johnson Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/j/johnson-pump.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FJohnson-Pump.jpg&opt=w3',
  alt: 'Johnson-Pump'
}, {
  name: 'Laing Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/l/laing-pumps.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FLaing-Pump-Logo.jpg&opt=w3',
  alt: 'Laing-Pump'
}, {
  name: 'Liberty Process Equipment',
  href: 'https://www.clrmarine.com/462m4/manufacturers/l/liberty-process-equipment.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLiberty_Process%2FLIBERTY-PROCESS-EQUIPMENT.jpg&opt=w3',
  alt: 'LIBERTY_PROCESS_EQUIPMENT-logo'
}, {
  name: 'Little Giant Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/l/little-giant-pumps.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FLittle-Giant-Pumps.jpg&opt=w3',
  alt: 'Little-Giant-Pumps'
}, {
  name: 'Lovejoy',
  href: 'https://www.clrmarine.com/462m4/manufacturers/l/lovejoy.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLovejoy%2FLovejoy.jpg&opt=w3',
  alt: 'Lovejoy_by_Timken-logo'
}, {
  name: 'Lutz Drum Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/l/lutz-pumps.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FLutz-Pumps.jpg&opt=w3',
  alt: 'Lutz-Pumps'
}, {
  name: 'March Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/m/march-pumps.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FMarch-Pumps.jpg&opt=w3',
  alt: 'March-Pumps'
}, {
  name: 'Mate USA Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/m/mate-usa-pumps.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FMate-USA.jpg&opt=w3',
  alt: 'Mate USA Pumps'
}, {
  name: 'MDM Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/m/mdm-industrial-pumps-fluid-solutions.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FMDM-Logo.jpg&opt=w3',
  alt: 'MDM Pumps'
}, {
  name: 'Meyers Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/m/myers-fluid-pumps.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FMyers%20Pump%2FMeyers.jpg&opt=w3',
  alt: 'Myers_Pumps'
}, {
  name: 'Micropump',
  href: 'https://www.clrmarine.com/462m4/manufacturers/m/micropump-gear-pumps-replacement-parts.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FMicropump.jpg&opt=w3',
  alt: 'Micropump'
}, {
  name: 'MP Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/m/mp-pump-centrifugal-pumps-marine-pumps.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FMP-Pumps.jpg&opt=w3',
  alt: 'MP-Pumps'
}, {
  name: 'MTH Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/m/mth-industrial-pumps-impellers-seals.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FMTH-Pumps%2FMTH-Pump-Logo.jpg&opt=w3',
  alt: 'MTH_Pumps_Logo'
}, {
  name: 'Northern Lights Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/n/northern-lights.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FNorthern-Lights.jpg&opt=w3',
  alt: 'Northern-Lights'
}, {
  name: 'Oberdorfer Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/o/oberdorfer-pumps.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FOberdorfer-Pumps.jpg&opt=w3',
  alt: 'Oberdorfer-Pumps'
}, {
  name: 'Onan Marine Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/o/onan-generator-pumps.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FOnan-Cummins-Pumps.jpg&opt=w3',
  alt: 'Onan-Cummins-Pumps'
}, {
  name: 'Perkins Engine Cooling Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/p/perkins-engine-raw-water-cooling-pumps.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FPerkins_Marine%2FPerkins.jpg&opt=w3',
  alt: 'Perkins Marine Pumps and Parts'
}, {
  name: 'Price Pump',
  href: 'https://www.clrmarine.com/462m4/manufacturers/p/price-pump-centrifugal-pumps.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FPrice_Pump%2FPrice_Pump.jpg&opt=w3',
  alt: 'Price_Pump_Logo'
}, {
  name: 'Primetime Pump',
  href: 'https://www.clrmarine.com/462m4/manufacturers/p/primetime-self-priming-centrifugal-pumps.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FPrimetime-Pumps.jpg&opt=w3',
  alt: 'Primetime-Pumps'
}, {
  name: 'Proven Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/p/proven-pump-solutions-for-industrial.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FProven-Pumps-Logo.jpg&opt=w3',
  alt: 'Proven-Pumps'
}, {
  name: 'PulsaFeeder',
  href: 'https://www.clrmarine.com/693m4/manufacturers/p/pulsafeeder.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FPulsaFeeder.jpg&opt=w3',
  alt: 'PulsaFeeder'
}, {
  name: 'Raritan Marine',
  href: 'https://www.clrmarine.com/462m4/manufacturers/r/raritan-marine-water-sanitation-solutions.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FRaritan-Pumps.jpg&opt=w3',
  alt: 'Raritan-Pumps'
}, {
  name: 'Robbins & Myers Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/r/robbins-myers-pumps-pump-parts.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FRobbins%20%26%20Myers%2Frobbins-and-myers.jpg&opt=w3',
  alt: 'Robbins & Myers Pumps & Pump Parts'
}, {
  name: 'Roper Pump Company',
  href: 'https://www.clrmarine.com/462m4/manufacturers/r/roper-gear-pumps-fluid-transfer-pumps.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FRoper%20Pumps%2FRoper_Logo2.jpg&opt=w3',
  alt: 'Roper Pump Company'
}, {
  name: 'Rule Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/r/rule-pumps-marine-water-transfer-pumps.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FRule.jpg&opt=w3',
  alt: 'Rule'
}, {
  name: 'Scot Pump',
  href: 'https://www.clrmarine.com/462m4/manufacturers/s/scot-pump-marine-industrial-centrifugal-pumps.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FScot_Pump.jpg&opt=w3',
  alt: 'Scot Pump'
}, {
  name: 'Sealand Marine Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/s/sealand.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FSealand-Pumps.jpg&opt=w3',
  alt: 'Sealand-Pumps'
}, {
  name: 'Sherwood Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/s/sherwood-marine-engine-cooling-pumps.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FSherwood-Pumps.jpg&opt=w3',
  alt: 'Sherwood-Pumps'
}, {
  name: 'Shurflo Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/s/shurflo-pumps-and-pump-parts.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FShurflo-Pumps.jpg&opt=w3',
  alt: 'Shurflo-Pumps'
}, {
  name: 'Simer Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/s/simer-pumps-industrial-home-water-systems.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2Fsimer.jpg&opt=w3',
  alt: 'simer'
}, {
  name: 'Sta-Rite Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/s/sta-rite-pumps-and-parts.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FSta-Rite-Pumps.jpg&opt=w3',
  alt: 'Sta-Rite-Pumps'
}, {
  name: 'Tuthill Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/t/tuthill-pumps-for-fuel-oil-industrial-pumps.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FTuthill%2FTuthill_Pumps.jpg&opt=w3',
  alt: 'Tuthill_Pumps'
}, {
  name: 'Ultra Safety Systems Bilge Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/u/ultra-safety-bilge-alarms-high-water-detection-systems.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FUltra%20Safety%20Systems%2FUltra-Safety-Systems-Inc.jpg&opt=w3',
  alt: 'Ultra Safety Systems Inc'
}, {
  name: 'Walbro Fuel Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/w/walbro-fuel-pumps-for-engines.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FPumps%2FWalbro-logo.jpg&opt=w3',
  alt: 'Walbro Fuel Pumps'
}, {
  name: 'Weinman Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/w/weinman-pumps.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FWeinman-Pumps%2FWeinman_Pumps_Logo.jpg&opt=w3',
  alt: 'Weinman_Pumps_Logo'
}, {
  name: 'Westerbeke Marine Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/w/westerbeke-marine-replacement-parts.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FWesterbeke%2FWesterbeke-Marine-Pumps.jpg&opt=w3',
  alt: 'Westerbeke Marine Pumps'
}, {
  name: 'Whale Marine Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/w/whale-marine-water-pump-systems.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FLOGOs%2FPumps%2FWhale.jpg&opt=w3',
  alt: 'Whale'
}, {
  name: 'Yamada Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/y/yamada-aodd-pumps-for-fluid-transfer.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FPumps%2FYamada-America.jpg&opt=w3',
  alt: 'Yamada-America'
}, {
  name: 'Yanmar Marine Pumps',
  href: 'https://www.clrmarine.com/462m4/manufacturers/y/yanmar-marine-diesel-engine-pumps-parts.html',
  src: '//drwzpk38qkpfb.cloudfront.net/core/getthumb?site=2891&user=2256&v=1&w=250&h=150&file=uploaded%2Fimages%2FPumps%2FYanmar-Marine.jpg&opt=w3',
  alt: 'Yanmar-Marine'
}];
const quickShop = [{
  label: 'All Products',
  href: '462.html',
  icon: Boxes
}, {
  label: 'Home Pumps',
  href: '462m4/home-pumps.html',
  icon: Home
}, {
  label: 'Industrial Pumps',
  href: '462m4/industrial-pumps.html',
  icon: Factory
}, {
  label: 'Marine Engine Parts',
  href: '462m4/marine-engine-parts.html',
  icon: Wrench
}, {
  label: 'Shop by Manufacturer',
  href: '462m4/manufacturers.html',
  icon: Store
}];
export function Manufacturers() {
  return <section className="w-full bg-slate-50 border-b border-slate-200" data-id="element-77">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-14" data-id="element-78">
        {/* Section header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-6" data-id="element-79">
          <div data-id="element-80">
            <div className="inline-flex items-center gap-2 text-marine-blue text-xs font-semibold uppercase tracking-wider mb-2" data-id="element-81">
              <ShoppingBag className="w-4 h-4" data-id="element-82" />
              Shop the Catalog
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-marine-navy mb-2" data-id="element-83">
              Shop Pumps by Manufacturer
            </h2>
            <p className="text-slate-600 max-w-2xl" data-id="element-84">
              Select a manufacturer below to browse pumps, pump parts,
              impellers, repair kits, and related products.
            </p>
          </div>
          <a href="462m4/manufacturers.html" className="hidden md:inline-flex items-center gap-1 text-sm font-semibold text-marine-blue hover:text-marine-navy whitespace-nowrap" data-id="element-85">
            View all manufacturers
            <ArrowRight className="w-4 h-4" data-id="element-86" />
          </a>
        </div>

        {/* Quick Shop strip */}
        <div className="flex flex-wrap gap-2 mb-8 pb-6 border-b border-slate-200" data-id="element-87">
          {quickShop.map(q => <a key={q.label} href={q.href} className="inline-flex items-center gap-2 bg-white border border-slate-200 hover:border-marine-blue hover:text-marine-blue text-slate-700 text-sm font-medium px-3.5 py-2 rounded-full transition-colors duration-150 shadow-sm" data-id="element-88">
              <q.icon className="w-4 h-4" data-id="element-89" />
              {q.label}
            </a>)}
        </div>

        {/* Manufacturer grid — all 74 cards */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-3" data-id="element-90">
          {manufacturers.map(mfg => <a key={mfg.name + mfg.href} href={mfg.href} title={mfg.name} className="group flex flex-col bg-white rounded-lg border border-slate-200 hover:border-marine-blue hover:shadow-md transition-all duration-150 overflow-hidden" style={{
          minHeight: '130px'
        }} data-id="element-91">
              <div className="flex-1 flex items-center justify-center px-3 pt-3 pb-2" style={{
            minHeight: '75px'
          }} data-id="element-92">
                <img src={mfg.src} alt={mfg.alt} title={mfg.name} loading="lazy" className="max-h-[65px] max-w-full object-contain" data-id="element-93" />
              </div>
              <div className="px-2 pb-2.5 pt-1 border-t border-slate-100" data-id="element-94">
                <span className="block text-xs sm:text-[13px] font-semibold text-slate-800 group-hover:text-marine-blue text-center leading-tight" data-id="element-95">
                  {mfg.name}
                </span>
              </div>
            </a>)}
        </div>

        <div className="md:hidden mt-6 text-center" data-id="element-96">
          <a href="462m4/manufacturers.html" className="inline-flex items-center gap-1 text-sm font-semibold text-marine-blue hover:text-marine-navy" data-id="element-97">
            View all manufacturers
            <ArrowRight className="w-4 h-4" data-id="element-98" />
          </a>
        </div>
      </div>
    </section>;
}